import React, { useState } from 'react';
import { consoleService } from '../../services/consoleService';
import './SendNotification.scss';

const SendNotification: React.FC = () => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [successMessage, setSuccessMessage] = useState<string | null>(null);
  
  // Form state - matching AdminNoticeNotif struct
  const [title, setTitle] = useState('');
  const [message, setMessage] = useState('');
  const [subject, setSubject] = useState('');
  const [code, setCode] = useState(202);
  const [persistent, setPersistent] = useState(true);
  
  // Batch notification state
  const [usernames, setUsernames] = useState('');

  const handleSendNotification = async () => {
    if (!usernames.trim() || !subject || !title || !message) {
      setError('Usernames, Subject, Title and Message are required');
      return;
    }

    const usernameList = usernames.split(',').map(u => u.trim()).filter(u => u);
    if (usernameList.length === 0) {
      setError('At least one username is required');
      return;
    }

    try {
      setLoading(true);
      setError(null);

      // Build content JSON matching AdminNoticeNotif struct
      const contentObj = {
        title: title,
        message: message
      };

      await consoleService.callRpcFunction({
        id: 'send_custom_notification_by_system',
        body: JSON.stringify({
          usernames: usernameList,
          subject: subject,
          content: JSON.stringify(contentObj),
          sender: '00000000-0000-0000-0000-000000000000',
          code: code,
          persistent: persistent
        }),
        user_id: '00000000-0000-0000-0000-000000000000',
        http_key: 'game_asDFGHyhu_http487ewmdc04356lvdme09'
      });

      setSuccessMessage(`Notification sent to ${usernameList.length} user(s)!`);
      setTimeout(() => setSuccessMessage(null), 3000);
      
      // Reset form
      setUsernames('');
      setSubject('');
      setTitle('');
      setMessage('');
    } catch (err: any) {
      setError(err.message || 'Failed to send notifications');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="send-notification-container">
      <div className="notification-header">
        <h1>📬 Send Notification</h1>
        <p>Send notifications to players</p>
      </div>

      {error && <div className="alert alert-danger">{error}</div>}
      {successMessage && <div className="alert alert-success">{successMessage}</div>}

      <div className="notification-form">
        <div className="form-section">
          <h3>👥 Target Players</h3>
          <div className="form-group">
            <label>Usernames *</label>
            <textarea
              value={usernames}
              onChange={(e) => setUsernames(e.target.value)}
              placeholder="Enter usernames separated by commas (e.g., user1, user2, user3)"
              rows={3}
            />
            <small>Comma-separated list of usernames</small>
          </div>
        </div>

        <div className="form-section">
          <h3>📝 Notification Content</h3>
          
          <div className="form-group">
            <label>Subject *</label>
            <input
              type="text"
              value={subject}
              onChange={(e) => setSubject(e.target.value)}
              placeholder="e.g., warning, info, reward"
            />
            <small>Notification subject/type identifier</small>
          </div>

          <div className="form-group">
            <label>Title *</label>
            <input
              type="text"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              placeholder="e.g., Hello Player!"
            />
            <small>Title displayed in the notification</small>
          </div>

          <div className="form-group">
            <label>Message *</label>
            <textarea
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              placeholder="Enter your message here..."
              rows={4}
            />
            <small>Message body displayed to the player</small>
          </div>

          <div className="form-row">
            <div className="form-group">
              <label>Persistent</label>
              <select 
                value={persistent ? 'true' : 'false'} 
                onChange={(e) => setPersistent(e.target.value === 'true')}
              >
                <option value="true">Yes (stored in database)</option>
                <option value="false">No (real-time only)</option>
              </select>
            </div>
          </div>
        </div>

        <div className="form-actions">
          <button 
            className="btn btn-primary btn-lg"
            onClick={handleSendNotification}
            disabled={loading}
          >
            {loading ? '📤 Sending...' : '📤 Send Notification'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SendNotification;
